<template>
  <div>
    <el-row v-loading="isLoading">
      <el-col>
        <el-row class="mb-3">
          <el-col>
            <el-alert
              type="warning"
              :closable="false"
            >
              This account is managed by <b>{{ $_.get(session, 'tenancy.licensee.name_display', 'OpenFreight') }}</b>.<br><a href="#">Learn More</a>
            </el-alert>
          </el-col>
        </el-row>

        <el-row>
          <el-col
            :xs="8"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
            style="text-align: center;"
          >
            <Avatar class="hidden-xs-only" />
            <Avatar
              size="medium"
              class="hidden-sm-and-up"
            />
          </el-col>

          <el-col
            :xs="16"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
          >
            <h2>{{ $_.get($user, 'instance.name_full', 'Unknown User') }}<br><small>{{ $_.get($user, 'instance.email', 'unknown.user@example.com') }}<br>{{ $_.get(session, 'team.description', 'Unknown Team') }}</small></h2>

            <el-dropdown
              split-button
              trigger="click"
              type="primary"
              size="medium"
              :disabled="isSigningOut"
              :loading="isSigningOut"
              @click="hasMultipleTeams ? showTeamSwitcherDialog() : signOut()"
              @command="command => command()"
            >
              {{ hasMultipleTeams ? 'Switch Teams' : 'Sign Out' }}
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="viewPreferences">
                  Preferences
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="hasMultipleTeams"
                  :command="signOut"
                  divided
                >
                  Sign out
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <Preferences
      v-if="isShowPreferences"
      :is-show.sync="isShowPreferences"
    />
  </div>
</template>

<script>
import Avatar from '@/components/Avatar'
import TeamSwitcherDialog from '@/components/TeamSwitcher/SwitchDialog'
import { CREATED, UPDATED } from '@/plugins/sdk/Events'
import Vue from 'vue'
import Preferences from '@/components/Navigation/Topbar/Preferences'

export default {
  components: {
    Avatar,
    Preferences
  },
  data () {
    return {
      isLoading: true,
      isSigningOut: false,
      teamSwitcherDialogVisible: false,
      teamSwitcherDialogInstance: undefined,
      session: undefined,
      isShowPreferences: false
    }
  },
  computed: {
    hasMultipleTeams () {
      let has = false

      if (this.session) {
        has = this.session.teams.length > 1
      }

      return has
    }
  },
  watch: {
    teamSwitcherDialogVisible (visible) {
      if (!visible && typeof this.teamSwitcherDialogInstance !== 'undefined') {
        this.teamSwitcherDialogInstance.$destroy()
        this.teamSwitcherDialogInstance.$el.remove()
        this.teamSwitcherDialogInstance = undefined
      }
    }
  },
  mounted () {
    this.loadSession()

    this
      .$sdk
      .session
      .on([CREATED, UPDATED], this.loadSession, this)
  },
  methods: {
    async loadSession () {
      this.isLoading = true
      this.session = await this.$session.instance
      this.isLoading = false
    },
    async signOut () {
      this.isSigningOut = true

      await this
        .$session
        .terminate()

      this
        .$router
        .push({ name: 'authentication-signin' })

      this.isSigningOut = false
    },
    showTeamSwitcherDialog () {
      const TeamSwitcherDialogClass = Vue.extend(TeamSwitcherDialog)

      this.teamSwitcherDialogInstance = new TeamSwitcherDialogClass(new Vue())

      this
        .teamSwitcherDialogInstance
        .$on('destroy', () => {
          this.teamSwitcherDialogVisible = false
        })

      this
        .teamSwitcherDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.teamSwitcherDialogInstance.$el)

      this.teamSwitcherDialogVisible = true
    },
    viewProfile () {
      //
    },
    viewPreferences () {
      this.isShowPreferences = true
    }
  }
}
</script>
